<template>
    <div id="getTitle">
        <div class="txt" :style="colorSty">获得称号</div>
        <div class="title" :style="titleBg">{{title}}</div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:[String]
        }
        
    },
    data(){
        return{
            
            colorSty:{},
            titleBg:{},
        }
    },
     mounted(){
        this.titleBg.background='url('+require('../assets/image/'+this.$route.query.type+'/chenghao.png')+')';
        this.titleBg.backgroundRepeat='no-repeat';
        this.titleBg.backgroundSize='100%';
        if(this.$route.query.type=='steam'){
            this.colorSty={
                color:'#5EE6FF',
            }
        }else if(this.$route.query.type=='psn'){
            this.colorSty={
                color:'#5EA6FF'
            }
        }else if(this.$route.query.type=='xbox'){
             this.colorSty={
                color:'#5EFF97'
            }
        }else if(this.$route.query.type=='epic'){
            this.colorSty={
                color:'#FF5E5E'
            }
        }
    },
}
</script>

<style>
#getTitle{
    width: 100%;
    text-align: center;
    margin-top: 1.45rem;
}
#getTitle .txt{
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    margin-bottom: 0.55rem;
}
#getTitle .title{
    width: 10.4rem;
    height: 3rem;
    /* background: url('../assets/image/steam/chenghao.png') no-repeat; */
    background-size: 100%;
    margin: 0 auto;
    font-size: 1.4rem;
    font-family: chenghao;
    color: #FFFFFF;
    line-height: 2.8rem;
}

</style>